import type React from "react";
import { type DetailedHTMLProps, type HTMLAttributes } from "react";
import { usePdpWebComponentUrls } from "~/features/productDetails/context/PdpWebComponentUrlsContext";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { useScript } from "~/common/hooks/useScript";
import { useIsWebComponentEnabled, WebcomponentToggle } from "~/features/productDetails/models/WebcomponentToggle";
import classNames from "classnames";
import { NumberFormatter } from "~/common/utils/NumberFormatter";

interface MountingManagerTabProps {
  mountingManagerURL: string;
  designation?: string;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "mounting-manager": DetailedHTMLProps<
        HTMLAttributes<HTMLElement> & {
          bearing?: string;
          language?: string;
          separator?: "point" | "comma";
        },
        HTMLElement
      >;
    }
  }
}

const MountingManagerTab: React.FC<MountingManagerTabProps> = ({ mountingManagerURL, designation }) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const isWebComponentEnabled = useIsWebComponentEnabled(WebcomponentToggle.MOUNTING_MANAGER);
  const { mountingMgrWebComponentUrl } = usePdpWebComponentUrls();

  useScript(mountingMgrWebComponentUrl);

  return (
    <div
      className={classNames("scha__ignore-margins", {
        "w-100": !isDesktop,
      })}
    >
      {isWebComponentEnabled ? (
        <mounting-manager
          bearing={designation}
          language={CURRENT_LANGUAGE}
          separator={NumberFormatter.getDecimalSeparatorName()}
        />
      ) : (
        <iframe className="scha__pdp-iframe" id="mmIframe" src={mountingManagerURL} scrolling="yes" />
      )}
    </div>
  );
};

export default MountingManagerTab;
